import { useGetList, useLocaleState } from 'react-admin';
import { localizedJsonText } from '../../utils/localizedJsonText';

const useVenues = () => {
  const [locale] = useLocaleState();
  const { data, isLoading, error } = useGetList('venues', {
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'name', order: 'ASC' },
  });

  if (isLoading || error || !data) {
    return [];
  }

  return data.map((venue) => ({
    id: venue.id,
    label: localizedJsonText(venue.name, locale, venue.id),
  }));
};

export default useVenues;
